import React, { useState } from 'react';

export const BenefitsSection: React.FC = () => {
  const [selectedBenefit, setSelectedBenefit] = useState<string | null>(null);

  const benefits = [
    {
      id: 'verified',
      icon: 'ri-shield-check-line',
      title: 'Profissionais Verificados',
      description: 'Todos os nossos profissionais passam por rigoroso processo de verificação, incluindo análise de documentos, experiência e referências.',
      details: 'Nosso processo de verificação inclui: análise completa de documentos pessoais e profissionais, verificação de experiência através de projetos anteriores, checagem de referências com clientes passados.'
    },
    {
      id: 'fast',
      icon: 'ri-time-line',
      title: 'Processo Rápido',
      description: 'Encontre o profissional ideal em minutos. Nossa tecnologia conecta você rapidamente com quem tem o perfil perfeito para seu projeto.',
      details: 'Nosso algoritmo inteligente analisa seu projeto e localização para encontrar os profissionais mais adequados em segundos. O sistema considera especialidade, disponibilidade, avaliações, proximidade geográfica e histórico de projetos similares. Em média, nossos usuários recebem as primeiras propostas em menos de 5 dias após publicar seu projeto.'
    },
    {
      id: 'support',
      icon: 'ri-customer-service-2-line',
      title: 'Suporte Total',
      description: 'Nossa equipe especializada acompanha seu projeto do início ao fim, garantindo que tudo saia conforme o planejado.',
      details: 'Oferecemos suporte aos nossos clientes: mediação entre cliente e profissional, acompanhamento ao decorrer da obra. Nossa equipe está sempre disponível para garantir o sucesso do seu projeto.'
    },
    {
      id: 'fair-price',
      icon: 'ri-money-dollar-circle-line',
      title: 'Preços Justos',
      description: 'Compare orçamentos de diferentes profissionais e escolha a melhor opção custo-benefício para seu projeto.',
      details: 'Nossa plataforma promove transparência total nos preços. Você recebe múltiplos orçamentos detalhados, pode comparar preços e serviços inclusos, visualizar avaliações de outros clientes, e negociar diretamente com os profissionais. Garantimos que você sempre tenha acesso aos melhores preços do mercado.'
    }
  ];

  const openModal = (benefitId: string) => {
    setSelectedBenefit(benefitId);
  };

  const closeModal = () => {
    setSelectedBenefit(null);
  };

  const selectedBenefitData = benefits.find(b => b.id === selectedBenefit);

  return (
    <section id="beneficios" className="py-8 md:py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-20">
          <h2 className="text-2xl md:text-5xl font-bold text-slate-900 mb-6 md:mb-8">
            Veja a <span className="text-orange-500">Diferença</span> que Fazemos
          </h2>
          <p className="text-base md:text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            Nossa plataforma conecta você aos melhores profissionais da construção civil, 
            garantindo qualidade, segurança e resultados excepcionais em cada projeto.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
          {/* Profissionais Verificados */}
          <div className="bg-white rounded-lg md:rounded-2xl p-4 md:p-8 shadow-md border border-gray-100 hover:shadow-xl transition-all duration-300 group flex flex-col h-full cursor-pointer hover:border-orange-200" onClick={() => openModal('verified')}>
            <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg md:rounded-2xl flex items-center justify-center mx-auto mb-4 md:mb-6 group-hover:scale-110 transition-transform duration-300">
              <i className="ri-shield-check-line text-lg md:text-2xl text-white"></i>
            </div>
            <h3 className="text-sm md:text-xl font-bold text-slate-900 text-center">Profissionais Verificados</h3>
            <p className="text-xs md:text-sm text-slate-600 leading-relaxed text-center mt-2 md:mt-4 flex-grow hidden md:block">
              Todos os nossos profissionais passam por rigoroso processo de verificação, 
              incluindo análise de documentos, experiência e referências.
            </p>
            <div className="text-center mt-2 md:mt-4">
              <span className="text-xs text-orange-500 font-medium">Clique para saber mais</span>
            </div>
          </div>

          {/* Processo Rápido */}
          <div className="bg-white rounded-lg md:rounded-2xl p-4 md:p-8 shadow-md border border-gray-100 hover:shadow-xl transition-all duration-300 group flex flex-col h-full cursor-pointer hover:border-orange-200" onClick={() => openModal('fast')}>
            <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg md:rounded-2xl flex items-center justify-center mx-auto mb-4 md:mb-6 group-hover:scale-110 transition-transform duration-300">
              <i className="ri-time-line text-lg md:text-2xl text-white"></i>
            </div>
            <h3 className="text-sm md:text-xl font-bold text-slate-900 text-center">Processo Rápido</h3>
            <p className="text-xs md:text-sm text-slate-600 leading-relaxed text-center mt-2 md:mt-4 flex-grow hidden md:block">
              Encontre o profissional ideal em minutos. Nossa tecnologia conecta 
              você rapidamente com quem tem o perfil perfeito para seu projeto.
            </p>
            <div className="text-center mt-2 md:mt-4">
              <span className="text-xs text-orange-500 font-medium">Clique para saber mais</span>
            </div>
          </div>

          {/* Suporte Total */}
          <div className="bg-white rounded-lg md:rounded-2xl p-4 md:p-8 shadow-md border border-gray-100 hover:shadow-xl transition-all duration-300 group flex flex-col h-full cursor-pointer hover:border-orange-200" onClick={() => openModal('support')}>
            <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg md:rounded-2xl flex items-center justify-center mx-auto mb-4 md:mb-6 group-hover:scale-110 transition-transform duration-300">
              <i className="ri-customer-service-2-line text-lg md:text-2xl text-white"></i>
            </div>
            <h3 className="text-sm md:text-xl font-bold text-slate-900 text-center">Suporte Total</h3>
            <p className="text-xs md:text-sm text-slate-600 leading-relaxed text-center mt-2 md:mt-4 flex-grow hidden md:block">
              Nossa equipe especializada acompanha seu projeto do início ao fim, 
              garantindo que tudo saia conforme o planejado.
            </p>
            <div className="text-center mt-2 md:mt-4">
              <span className="text-xs text-orange-500 font-medium">Clique para saber mais</span>
            </div>
          </div>

          {/* Preços Justos */}
          <div className="bg-white rounded-lg md:rounded-2xl p-4 md:p-8 shadow-md border border-gray-100 hover:shadow-xl transition-all duration-300 group flex flex-col h-full cursor-pointer hover:border-orange-200" onClick={() => openModal('fair-price')}>
            <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg md:rounded-2xl flex items-center justify-center mx-auto mb-4 md:mb-6 group-hover:scale-110 transition-transform duration-300">
              <i className="ri-money-dollar-circle-line text-lg md:text-2xl text-white"></i>
            </div>
            <h3 className="text-sm md:text-xl font-bold text-slate-900 text-center">Preços Justos</h3>
            <p className="text-xs md:text-sm text-slate-600 leading-relaxed text-center mt-2 md:mt-4 flex-grow hidden md:block">
              Compare orçamentos de diferentes profissionais e escolha a melhor 
              opção custo-benefício para seu projeto.
            </p>
            <div className="text-center mt-2 md:mt-4">
              <span className="text-xs text-orange-500 font-medium">Clique para saber mais</span>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {selectedBenefit && selectedBenefitData && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={closeModal}>
          <div className="bg-white rounded-2xl p-6 md:p-8 max-w-2xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-start mb-6">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center">
                  <i className={`${selectedBenefitData.icon} text-xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900">{selectedBenefitData.title}</h3>
              </div>
              <button 
                onClick={closeModal}
                className="text-gray-400 hover:text-gray-600 text-2xl font-bold"
              >
                ×
              </button>
            </div>
            
            <p className="text-gray-600 leading-relaxed text-lg">
              {selectedBenefitData.details}
            </p>
          </div>
        </div>
      )}
    </section>
  );
};